import { SmopOrderStatusEnum } from "@saleor/types/globalTypes";
import moment from "moment";

export const getDefaultTab = getFilterTabs => [
  {
    data: {
      status: SmopOrderStatusEnum.NEW_ORDER
    },
    name: "New Order"
  },
  {
    data: {
      status: SmopOrderStatusEnum.ACKNOWLEDGED
    },
    name: "Acknowledged"
  },
  {
    data: {
      status: SmopOrderStatusEnum.READY
    },
    name: "Ready"
  },
  {
    data: {
      status: SmopOrderStatusEnum.COLLECTED
    },
    name: "Collected"
  },
  {
    data: {
      status: SmopOrderStatusEnum.RECEIVED_AT_FC
    },
    name: "Received at FC"
  },
  {
    data: {
      status: SmopOrderStatusEnum.PACKED
    },
    name: "Packed"
  },
  {
    data: {
      status: SmopOrderStatusEnum.READY_TO_SHIP
    },
    name: "Ready To Ship"
  },
  {
    data: {
      status: SmopOrderStatusEnum.SHIPPED
    },
    name: "Shipped"
  },
  {
    data: {
      status: SmopOrderStatusEnum.RETURN_TO_FC
    },
    name: "Returned to FC"
  },
  {
    data: {
      status: SmopOrderStatusEnum.COMPLETED
    },
    name: "Completed"
  },
  {
    data: {
      status: SmopOrderStatusEnum.CANCELED
    },
    name: "Cancelled"
  },
  ...getFilterTabs()
];

export const getMoment = (format: string, condition: number = 0) =>
  moment(new Date())
    .add(condition, "days")
    .format(format);

export const hasAppliedFilters = params => {
  const {
    createdFrom,
    createdTo,
    customer,
    deliveryType,
    orderCode,
    payment,
    query,
    riderFirstName,
    riderLastName,
    shippingFrom,
    shippingTo,
    store,
    verticalType
  } = params;
  if (
    customer ||
    deliveryType ||
    orderCode ||
    payment ||
    query ||
    riderFirstName ||
    riderLastName ||
    shippingFrom ||
    shippingTo ||
    store ||
    verticalType
  ) {
    // FIX ME: REFACTOR CONDITION
    if (createdFrom || createdTo || shippingFrom || shippingTo) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};

export function getUrlParam(name) {
  const results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  return results ? true : false;
}
